import {
	DialogHandler,
	FullPageLoaderHandler,
	NotificationHandler,
	OverlayHandler,
	TaskBarHandler,
} from "cakemail-ui-components/lib/react";
import { clearBackToFlows } from "utils/urlUtils";
import fetchRoute from "./routes";

export function fakeBtnLoad(ref) { }

export function clearGlobalItems() {
	//window.localStorage.clear(); //Need to clear stuff manually instead of everytime
	const bigDataKey = ["anonymous_", "template-campaign-", "automations-", "current_app_brand", "modified_app_brand", "current_app_brand_unpublished_changes", "flow_", "bee-email-"];
	//Cleanup big data set in localStorage to liberate space
	for (let i = window.localStorage.length - 1; i >= 0; i--) {
		const key = window.localStorage.key(i);

		bigDataKey.forEach((k) => {
			if (key.includes(k)) {
				// Remove the key from local storage
				window.localStorage.removeItem(key);
			}
		});
	}


	window.sessionStorage.clear();
	DialogHandler.clearQueue();
	DialogHandler.hide();
	NotificationHandler.clearQueue();
	NotificationHandler.hide();
	FullPageLoaderHandler.hide();
	OverlayHandler.hide();
	TaskBarHandler.hide();
	clearBackToFlows();
}

export function logoRedirection(signIn) {
	window.location = "#" + fetchRoute(signIn ? "signIn" : "dashboard");
}
